/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_AlertInputs */

const en_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const ar_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تنبيه`)
};

const bn_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const de_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const es_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const fr_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const pt_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const zh_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const tr_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const ru_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

const pl_svtag_alert = /** @type {(inputs: Svtag_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ALERT`)
};

/**
* | output |
* | --- |
* | "#ALERT" |
*
* @param {Svtag_AlertInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_alert = /** @type {((inputs?: Svtag_AlertInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_AlertInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_alert(inputs)
	if (locale === "bn") return bn_svtag_alert(inputs)
	if (locale === "de") return de_svtag_alert(inputs)
	if (locale === "es") return es_svtag_alert(inputs)
	if (locale === "fr") return fr_svtag_alert(inputs)
	if (locale === "pt") return pt_svtag_alert(inputs)
	if (locale === "zh") return zh_svtag_alert(inputs)
	if (locale === "tr") return tr_svtag_alert(inputs)
	if (locale === "ru") return ru_svtag_alert(inputs)
	if (locale === "pl") return pl_svtag_alert(inputs)
	return en_svtag_alert(inputs)
});